import { Link } from 'react-router-dom';
import { To } from 'history';

// material-ui
import { ButtonBase } from '@mui/material';
import { SxProps } from '@mui/system';

// project imports
import Logo from './LogoMain';
import LogoIcon from './LogoIcon';
import { APP_DEFAULT_PATH } from 'config';
import { useAllowedControllers } from 'utils/menu/accessController';

// ==============================|| MAIN LOGO ||============================== //

interface Props {
  reverse?: boolean;
  isIcon?: boolean;
  sx?: SxProps;
  to?: To;
}

const LogoSection = ({ reverse, isIcon, sx, to }: Props) => {
  const formatController = (controller: string) => {
    const [first, ...rest] = controller.split('-');
    return `/${first}/${rest.join('-')}`;
  };

  const allowedControllers = useAllowedControllers();
  const normalizedAllowedControllers = allowedControllers.map(formatController);
  const dashboardRoutes = ['/dashboard/admin', '/dashboard/process', '/dashboard/qa-manager'];
  const hasDashboardRoute = dashboardRoutes.some((route) => normalizedAllowedControllers.includes(route));
  const order = ['/dashboard', '/design', '/training', '/review', '/report', '/admin'];

  const groupedRoutes = normalizedAllowedControllers.reduce((acc, route) => {
    const firstPart: any = route.split('/').slice(0, 2).join('/');
    if (!acc[firstPart]) acc[firstPart] = [];
    acc[firstPart].push(route);
    return acc;
  }, {} as any);

  const orderedRoutes = order.flatMap((section) => groupedRoutes[section] || []);
  const path = orderedRoutes[0] || APP_DEFAULT_PATH;

  const firstPart = path.split('/').slice(0, 2).join('/');

  return (
    <ButtonBase disableRipple component={Link} to={hasDashboardRoute ? APP_DEFAULT_PATH : firstPart} sx={sx}>
      {isIcon ? <LogoIcon /> : <Logo reverse={reverse} />}
    </ButtonBase>
  );
};

export default LogoSection;
